module.exports = __webpack_public_path__ + "static/media/datatrack-tick.bdc29340.svg";